// "12.5 د.ك" reads correctly inside Arabic text; "12.5 KWD" gets flipped by
// the bidi algorithm to "KWD 12.5". Western digits, as everywhere on the site.
const SYMBOLS = { KWD: "د.ك", SAR: "ر.س", AED: "د.إ", BHD: "د.ب", QAR: "ر.ق", OMR: "ر.ع" };

export const currencyLabel = (currency) => SYMBOLS[currency] || currency || "";

export const formatMoney = (amount, currency, decimals) => {
  const n = Number(amount);
  const value =
    decimals == null || !Number.isFinite(n) ? String(amount) : n.toFixed(decimals);
  return `${value} ${currencyLabel(currency)}`.trim();
};
